export default __webpack_public_path__ + "static/media/illustration-work-1-w@2x.9c0ead20.webp";